import { P } from '@components/typography/new';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { Flex } from '@components/grid';
import { Icon } from '@components/icons';

const GroupDetailsButton = ({ onClick }) => {
  return (
    <Flex
      onClick={onClick}
      py="12px"
      px="16px"
      bg="white"
      borderRadius="16px"
      alignItems="center"
      as="button"
      aria-label="View group order"
    >
      <Icon name="groupOrder" height="32px" width="32px" mr="8px" aria-hidden="true" />
      <P variant="standard-semi-bold" style={{ whiteSpace: 'nowrap' }} aria-hidden="true">
        View group order
      </P>
    </Flex>
  );
};

GroupDetailsButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const ObservedGroupDetailsButton = observer(GroupDetailsButton);

export { ObservedGroupDetailsButton as GroupDetailsButton };
